import { useEffect, useRef, useState } from "react";
// import BeakerMaskedSquare from "./BeakerMaskedVisual";
import beakerMask from "./beakerSlim.png"; // or beaker.svg

const WaveformVisualizer = ({ stream, isRecording, timer }) => {
  const [waveform, setWaveform] = useState([]);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);
  const sourceRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    if (!stream) return;

    // Setup AudioContext and Analyser
    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    analyserRef.current = audioContextRef.current.createAnalyser();
    analyserRef.current.fftSize = 64; // low resolution for fewer bars
    const bufferLength = analyserRef.current.frequencyBinCount;
    dataArrayRef.current = new Uint8Array(bufferLength);

    sourceRef.current = audioContextRef.current.createMediaStreamSource(stream);
    sourceRef.current.connect(analyserRef.current);

    const updateWaveform = () => {
      analyserRef.current.getByteFrequencyData(dataArrayRef.current);
      setWaveform([...dataArrayRef.current]);
      animationRef.current = requestAnimationFrame(updateWaveform);
    };

    if (isRecording) updateWaveform();

    return () => {
      cancelAnimationFrame(animationRef.current);
      if (sourceRef.current) sourceRef.current.disconnect();
      if (audioContextRef.current) audioContextRef.current.close();
      sourceRef.current = null;
      audioContextRef.current = null;
      analyserRef.current = null;
    };
  }, [stream, isRecording]);

  if (!isRecording || waveform.length === 0) return null;

  const maskStyle = {
    // Mask for standard browsers
    maskImage: `url(${beakerMask})`,
    maskRepeat: "no-repeat",
    maskSize: "cover",
    maskPosition: "center",
    // Mask for WebKit (Safari, Chrome)
    WebkitMaskImage: `url(${beakerMask})`,
    WebkitMaskRepeat: "no-repeat",
    WebkitMaskSize: "cover",
    WebkitMaskPosition: "center",
  };

  const truePercentage = timer < 60 ? ( (timer / 60) * 100 ) : 100;

  const percentage = truePercentage * 0.84; // Due to the nature of the image...100% is really 84 percent fill

  return (
    <div
      style={{
        ...maskStyle,
        display: "flex",
        flexDirection: 'column',
        alignItems: "center",
        justifyContent: "center",
        // height: "200px", // overall height of the waveform
        // width: "100%",
        // height: "100%", // overall height of the waveform
        // width: "200px",
        height: "250px", // overall height of the waveform
        width: "120px",
        // backgroundColor: "#ddd",
        backgroundColor: '#cacaca',
        borderRadius: "4px",
        overflow: "hidden",
        marginTop: "0.5rem",
        position: 'relative'
      }}
    >
      {waveform.slice().reverse().map((value, idx) => {
        const barWidth = (value / 255) * 100; // scale 0-255 to %
        return (
          <div
            key={idx}
            style={{
              height: "4px",
               margin: "1px 0px",
              // backgroundColor: "#d2275a",
              // backgroundColor: "#0a75aaff",
              backgroundColor: "#ffffff",
              width: `${barWidth}%`, // half above, half below
              // transform: "translateX(50%)", // center bars vertically
              // display: "inline-block",
            }}
          >
            {/* <div
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: "#d2275a",
                transform: `translateX(-50%) scaleX(2)`, // stretch from center
                transformOrigin: "center",
              }}
            /> */}
          </div>
        );
      })}
      <div style={{
        backgroundColor: '#44b0dd', // '#d2275a',
        height: `calc(${percentage}% - 0px)`,
        width: '100%',
        display: "flex",
        flexDirection: 'column',
        alignItems: "center",
        justifyContent: "center",
        position: 'absolute',
        bottom: '30px',
        zIndex: '-1'
      }}>
        &nbsp;
      </div>
    </div>
  );
};

export default WaveformVisualizer;
